export default __webpack_public_path__ + "static/media/SENAIT_FR_SEQ04.5467ec9d.mp3";